import { Swiper, Navigation, Pagination, Autoplay} from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        loop: true,
        autoplay: {
            delay: 5500,
            disableOnInteraction: false,
        },
        speed: 4000,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let ratesSlide = new Swiper(".rates-slide", {
        loop: true,
        autoplay: {
            delay: 'auto',
            disableOnInteraction: false,
        },
        slidesPerView: 4,
        speed: 4000,
        grabCursor: true,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 0,
            },
        },
        navigation: {
            nextEl: ".rates-button-next",
            prevEl: ".rates-button-prev",
        },
    });

    let depositionsSlide = new Swiper(".depositions-slide", {
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
            delay: 10000,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
        },
        navigation: {
            nextEl: ".depositions-button-next",
            prevEl: ".depositions-button-prev",
        },
    });

    // === AJUSTADO NO BACKEND ===
    // let discountSlide = new Swiper(".discount-slide", {
    //     slidesPerView: 4,
    //     spaceBetween: 20,
    //     autoplay: {
    //         delay: 10000,
    //     },
    //     breakpoints: {
    //         640: {
    //             slidesPerView: 1,
    //             spaceBetween: 10,
    //         },
    //         768: {
    //             slidesPerView: 2,
    //             spaceBetween: 10,
    //         },
    //         1024: {
    //             slidesPerView: 4,
    //             spaceBetween: 0,
    //         },
    //     },
    //     navigation: {
    //         nextEl: ".discounts-button-next",
    //         prevEl: ".discounts-button-prev",
    //     },
    // }); 

    let creditSlider = new Swiper(".credit-slider", {
        watchOverflow: true,
        slidesPerView: 2,
        spaceBetween: 32,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
        pagination: {
            el: ".credit-pagination",
            type: "bullets",
            clickable: true,
        },
    });
};
